import { tabMenuType, HeaderType } from '@utils/types';

// 다음 Post API 새창 option
export const postcodeOptions = {
    left: window.screen.width / 2 - 500 / 2,
    top: window.screen.height / 2 - 600 / 2
};
////////////////////// 네비게이션 //////////////////////
// 헤더
export const headerTabMenu: tabMenuType[] = [
    { dataText: '대시보드', pathname: '/dashboard' },
    { dataText: '회원', pathname: '/member/status' },
    { dataText: '상품', pathname: '/product' },
    { dataText: '운영', pathname: '/operation/qr' }
];
// 회원 관리 사이드 메뉴
export const memberTabMenu: tabMenuType[] = [
    { dataText: '회원별 현황', pathname: '/member/status' },
    { dataText: '탈퇴한 회원', pathname: '/member/secession' }
];
// 운영 관리 사이드 메뉴
export const operationTabMenu: tabMenuType[] = [
    { dataText: 'QR 현황', pathname: '/operation/qr' },
    { dataText: '상품', pathname: '/operation/product' },
    { dataText: '방침 및 규약', pathname: '/operation/policy' }
];
// 마스터 사이드 메뉴
export const masterTabMenu: tabMenuType[] = [
    { dataText: '운영자 관리', pathname: '/setting/sysop' },
    { dataText: 'QR 관리', pathname: '/setting/qr' },
    { dataText: '시스템 로그 내역', pathname: '/setting/log' }
];

////////////////////// 테이블 헤더 //////////////////////
// 대시보드 > 최근 등록 회원
export const latestJoinedTableHeader: HeaderType[] = [
    { label: '등록일', minWidth: 250, width: 20 },
    { label: '가입경로', minWidth: 170, width: 13 },
    { label: '회원명', minWidth: 170, width: 13 },
    { label: '이메일', minWidth: 330, width: 26 },
    { label: '전화번호', minWidth: 170, width: 13 },
    { label: '보유 카드', minWidth: 190, width: 15 }
];
// 회원 > 현황
export const memberStatusTableHeader: HeaderType[] = [
    { label: '가입일', minWidth: 180, width: 16 },
    { label: 'ID', minWidth: 140, width: 13 },
    { label: '로그인 연동', minWidth: 140, width: 13 },
    { label: '회원명', minWidth: 146, width: 13 },
    { label: '전화번호', minWidth: 152, width: 14 },
    { label: '이메일', minWidth: 270, width: 23 },
    { label: '등록 QR 수', minWidth: 89, width: 8 }
];
// 회원 > 현황 상세 > 등록 QR 정보
export const petInfoTableHeader: HeaderType[] = [
    { label: '등록일', minWidth: 124, width: 11 },
    { label: '표기명칭', minWidth: 168, width: 19 },
    { label: '이름', minWidth: 160, width: 17 },
    { label: '생일', minWidth: 100, width: 10 },
    { label: '등록번호', minWidth: 154, width: 15 },
    { label: 'QR ID', minWidth: 140, width: 18 },
    { label: '', minWidth: 70, width: 10 }
];
// 운영 > QR 현황
export const qrStatusTableHeader: HeaderType[] = [
    { label: '생성회차', minWidth: 104, width: 9 },
    { label: 'QR번호', minWidth: 152, width: 14 },
    { label: '반려동물 등록일', minWidth: 132, width: 12 },
    { label: '사용자명', minWidth: 120, width: 11 },
    { label: '휴대폰번호', minWidth: 140, width: 13 },
    { label: '이메일', minWidth: 240, width: 21 },
    { label: '등록번호', minWidth: 160, width: 14 },
    { label: '', minWidth: 69, width: 6 }
];
// 운영 > 상품 관리
export const manageProductTableHeader: HeaderType[] = [
    { label: '등록일', minWidth: 167, width: 15 },
    { label: '사진', minWidth: 60, width: 5 },
    { label: '상품명', minWidth: 160, width: 14 },
    { label: '지난달 클릭 수', minWidth: 120, width: 11 },
    { label: '누적 클릭 수', minWidth: 120, width: 11 },
    { label: '링크', minWidth: 300, width: 27 },
    { label: '금액', minWidth: 120, width: 11 },
    { label: '', minWidth: 70, width: 6 }
];
// 운영 > 방침 및 규약
export const policyTableHeader: HeaderType[] = [
    { label: '등록일시', minWidth: 182, width: 16 },
    { label: '구분', minWidth: 140, width: 13 },
    { label: '제목', minWidth: 572, width: 51 },
    { label: '생성자', minWidth: 223, width: 20 }
];
// 마스터 > 운영자 관리
export const operatorTableHeader: HeaderType[] = [
    { label: '등록일', minWidth: 204, width: 20 },
    { label: '계정명(이메일)', minWidth: 288, width: 26 },
    { label: '이름', minWidth: 123, width: 9 },
    { label: '직책', minWidth: 124, width: 10 },
    { label: '휴대폰번호', minWidth: 164, width: 15 },
    { label: '최근 로그인', minWidth: 214, width: 20 }
];
// 마스터 > QR 관리
export const qrTableHeader: HeaderType[] = [
    { label: 'ID(생성회차)', minWidth: 172, width: 14 },
    { label: '등록일', minWidth: 212, width: 19 },
    { label: '발행 수량', minWidth: 152, width: 14 },
    { label: '사용 수량', minWidth: 152, width: 14 },
    { label: '미사용 수량', minWidth: 152, width: 14 },
    { label: '사용률', minWidth: 152, width: 14 },
    { label: '', minWidth: 125, width: 11 }
];
// 마스터 > 시스템 로그 내역
export const systemLogTableHeader: HeaderType[] = [
    { label: '일시', minWidth: 170, width: 15 },
    { label: '구분', minWidth: 140, width: 13 },
    { label: '사용자', minWidth: 114, width: 10 },
    { label: '상세내용', minWidth: 693, width: 62 }
];
